
import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";
import { BaseResponse } from "../_types";
import { QueryKeys } from "../queryKeys";

interface IGetMerchantWithVknRequest {
  vkn: string;
}

type IGetMerchantWithVknResponse = BaseResponse<any>;

async function getMerchantWithVkn(vkn: string): Promise<IGetMerchantWithVknResponse> {
  try {
    const response = await axiosInstance.get("/Todeb/SearchLiabilityInfoWithVKN", {
      params: { taxNo: vkn }
    });
    return response.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any)?.error;
  }
} export function useGetMerchantWithVkn(vkn?: string) {
  return useQuery<any | undefined, Error>(
    [QueryKeys.GetMerchantWithVkn, vkn],
    () => getMerchantWithVkn(vkn!),
    { enabled: !!vkn }
  );
}
